<template>
  <div>
    <div class="form_wrap">
      <img src="@/assets/img/pic_banner.png" alt v-if="isEdit" />
      <div class="nav_pos mb_nav_pos" style="border-bottom: 1px solid #dbdbdb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <router-link to="/">首页</router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>供应商信息编辑</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <span class="title">基本信息</span>
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm1">
          <div class="form_left">
            <el-form-item label="供应商名称：" prop="SupplierName" label-width="180px">
              <el-input v-model="ruleForm.SupplierName" placeholder="请填写您公司的真实名称"></el-input>
            </el-form-item>
            <el-form-item label="供应商分类：" prop="SupplierType" label-width="180px">
              <div>
                <div><el-button icon="el-icon-search" @click.stop="openSupplierTypePage">选择供应商类型</el-button></div>
                <div v-for="(item, index) in ruleForm.SupplierTypeName" :key="index">{{ item }}</div>
              </div>
            </el-form-item>
            <el-form-item label="统一社会信用代码：" prop="SocialCreditCode" label-width="180px">
              <el-input v-model="ruleForm.SocialCreditCode" placeholder="请输入统一社会信用代码"></el-input>
            </el-form-item>
            <el-form-item label="引入来源：" prop="IntroductionSource" label-width="180px">
              <el-select v-model="ruleForm.IntroductionSource" class="width_full" placeholder="请选择" @change="IntroductionSourceFn">
                <el-option v-for="item in ruleForm.IntroductionSourceList" :key="item.value" :label="item.text" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="注册资本（万元）：" prop="RegisteredCapital" label-width="180px">
              <el-input-number :controls="false" class="input_number" placeholder="请填写注册资本" :min="0" v-model="ruleForm.RegisteredCapital"></el-input-number>
              <!-- <el-input v-model="ruleForm.RegisteredCapital" placeholder="请填写注册资本"></el-input> -->
            </el-form-item>
            <el-form-item label="实缴资本（万元）：" prop="PaidInCapital" label-width="180px">
              <el-input-number :controls="false" placeholder="实缴资金金额来自出资证明书" class="input_number" :min="0" v-model="ruleForm.PaidInCapital"></el-input-number>
              <!-- <el-input-number v-model="ruleForm.PaidInCapital" placeholder="实缴资金金额来自出资证明书"></el-input-number> -->
            </el-form-item>
            <el-form-item label="注册地址：" prop="RegisteredAddress" label-width="180px" class="cascader">
              <el-input placeholder="请输入注册地址" v-model="ruleForm.RegisteredAddress" class="input-with-select">
                <el-cascader filterable clearable class="addressCascader" slot="prepend" v-model="ruleForm.RegisteredAddressArr" :options="ruleForm.AdministrativeAreaList"></el-cascader>
              </el-input>
            </el-form-item>
          </div>
          <div class="form_right">
            <el-form-item label="供应商类别：" label-width="180px"> 法人或其他组织 </el-form-item>
            <el-form-item label="公司类型：" prop="CompanyType" label-width="180px" ref="CompanyType">
              <el-select v-model="ruleForm.CompanyType" placeholder="请选择" class="width_full" @change="CompanyTypeFn">
                <el-option v-for="item in ruleForm.CompanyTypeList" :key="item.value" :label="item.text" :value="item.value" :checked="item.selected"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="法定代表人：" prop="LegalRepresentative" label-width="180px">
              <el-input v-model="ruleForm.LegalRepresentative" placeholder="请填写法定代表人姓名"></el-input>
            </el-form-item>
            <el-form-item label="推荐人：" label-width="180px" prop="Referrer">
              <div style="width: 100%">
                <div style="padding-bottom: 10px">
                  <el-input placeholder="请输入推荐人手机" class="width_full1" v-model="ReferrerName"></el-input>
                  <el-button style="margin-left: 10px" type="primary" @click="querySearchAsync()">查找</el-button>
                </div>
                已选推荐人:
                <div class="name_wrap name_wrap2" v-if="ruleForm.Referrer != 0">
                  <span>{{ ruleForm.ReferrerName }}|{{ ruleForm.ReferrerMobile }}</span>
                  <i style="cursor: pointer" @click="deleteReferrerName()" class="el-icon-delete"></i>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="公司人数规模：" prop="StaffSize" label-width="180px">
              <el-select v-model="ruleForm.StaffSize" class="width_full">
                <el-option :label="item.text" :value="item.value" v-for="(item, index) in ruleForm.StaffSizeList" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公司维度：" prop="CompanyDimension" label-width="180px">
              <el-select v-model="ruleForm.CompanyDimension" class="width_full">
                <el-option :label="item.text" :value="item.value" v-for="(item, index) in ruleForm.CompanyList" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="办公地址：" prop="OfficeAddress" label-width="180px" class="cascader">
              <el-input placeholder="请输入办公地址" v-model="ruleForm.OfficeAddress" class="input-with-select">
                <el-cascader filterable clearable class="addressCascader" slot="prepend" v-model="ruleForm.OfficeAddressArr" :options="ruleForm.AdministrativeAreaList"></el-cascader>
              </el-input>
              <!-- <el-input v-model="ruleForm.OfficeAddress" placeholder="请填写办公地址"></el-input> -->
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span class="title">企业状况</span>
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm4">
          <div class="form_left">
            <el-form-item label="供应商性质：" prop="SupplierNature" label-width="180px">
              <el-select v-model="ruleForm.SupplierNature" class="width_full">
                <el-option :label="item.text" :value="item.value" v-for="(item, index) in ruleForm.SupplierNatureList" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="核心产品：" prop="SupplierProductList" label-width="180px">
              <div style="width: 100%">
                <div style="padding-bottom: 10px">
                  <el-select v-model="ruleForm.SupplierProductList" class="width_full" filterable clearable :multiple="true">
                    <el-option :label="item.ProductName" :value="item.ProductId" v-for="(item, index) in ruleForm.BaseProductList" :key="index"></el-option>
                  </el-select>
                </div>
                <div>
                  <el-input class="cascader" v-model="ruleForm.OtherSupplierProductList" placeholder="填写上面选择框未包含贵司的产品,多个以逗号分隔">
                    <template slot="prepend">自定义添加：</template>
                  </el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="经营范围：" prop="BusinessScope" label-width="180px">
              <el-input v-model="ruleForm.BusinessScope" type="textarea" rows="1" placeholder="请填写经营范围"></el-input>
            </el-form-item>
            <!-- <el-form-item label="邮政编码：" label-width="180px">
              <el-input v-model="ruleForm.PostalCode" maxlength="6" placeholder="请填写邮政编码"></el-input>
            </el-form-item> -->
            <el-form-item label="固定资产（万元）：" label-width="180px" prop="FixedAssets">
              <el-input-number :controls="false" placeholder="请填写固定资产" class="input_number" :min="0" v-model="ruleForm.FixedAssets"></el-input-number>
              <!-- <el-input v-model="ruleForm.FixedAssets" placeholder="请填写固定资产"></el-input> -->
            </el-form-item>
            <el-form-item label="生产工人数：" label-width="180px">
              <el-input-number :controls="false" placeholder="请填写生产工人数" class="input_number" :min="0" v-model="ruleForm.WorkerNumber"></el-input-number>
              <!-- <el-input type="number" v-model="ruleForm.WorkerNumber" placeholder="请填写生产工人数"></el-input> -->
            </el-form-item>
            <!-- <el-form-item label="质管负责人：" prop="QualityDirector" label-width="180px">
              <el-input v-model="ruleForm.QualityDirector" placeholder="请填写质管负责人"></el-input>
            </el-form-item> -->

            <el-form-item label="质量管理人数：" label-width="180px" prop="QualityManagerNumber">
              <el-input-number :controls="false" placeholder="请填写质量管理人数" class="input_number" :min="0" v-model="ruleForm.QualityManagerNumber"></el-input-number>
              <!-- <el-input type="number" v-model="ruleForm.QualityManagerNumber" placeholder="请填写质量管理人数"></el-input> -->
            </el-form-item>
            <!-- <el-form-item label="主要产品或服务：" label-width="180px" prop="MajorProject">
              <el-input v-model="ruleForm.MajorProject" type="textarea" rows="1" placeholder="请填写主要产品或服务"></el-input>
            </el-form-item> -->
            <el-form-item label="企业信誉：" label-width="180px" prop="CompanyReputation">
              <el-input v-model="ruleForm.CompanyReputation" type="textarea" rows="1" placeholder="请填写企业信誉"></el-input>
            </el-form-item>
          </div>
          <div class="form_right">
            <el-form-item label="纳税人类型：" prop="TaxPayerSize" label-width="180px">
              <el-select v-model="ruleForm.TaxPayerSize" class="width_full" placeholder="请选择">
                <el-option v-for="item in ruleForm.TaxPayerSizeList" :key="item.value" :label="item.text" :value="item.value" :checked="item.selected"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="核心产品的品牌：" prop="SupplierProductBrandList" label-width="180px">
              <div style="width: 100%">
                <div style="padding-bottom: 10px">
                  <el-select v-model="ruleForm.SupplierProductBrandList" class="width_full" filterable clearable :multiple="true">
                    <el-option :label="item.BrandName" :value="item.BrandId" v-for="(item, index) in ruleForm.BaseBrandLibrarieList" :key="index"></el-option>
                  </el-select>
                </div>
                <div>
                  <el-input class="cascader" v-model="ruleForm.OtherSupplierProductBrandList" placeholder="填写上面选择框未包含贵司的品牌,多个以逗号分隔">
                    <template slot="prepend">自定义添加：</template>
                  </el-input>
                </div>
              </div>
            </el-form-item>

            <!-- <el-form-item label="传真：" label-width="180px">
              <el-input v-model="ruleForm.Fax" placeholder="请填写传真"></el-input>
            </el-form-item> -->
            <el-form-item label="去年销售总额（万元）：" label-width="180px" prop="LastYearTotalSales">
              <el-input-number :controls="false" placeholder="请填写去年销售总额" class="input_number" :min="0" v-model="ruleForm.LastYearTotalSales"></el-input-number>
              <!-- <el-input v-model="ruleForm.LastYearTotalSales" placeholder="请填写去年销售总额"></el-input> -->
            </el-form-item>

            <el-form-item label="技术人员数：" label-width="180px" prop="TechnicianNumber">
              <el-input-number :controls="false" placeholder="请填写技术人员数" class="input_number" :min="0" v-model="ruleForm.TechnicianNumber"></el-input-number>
              <!-- <el-input v-model="ruleForm.TechnicianNumber" placeholder="请填写技术人员数"></el-input> -->
            </el-form-item>
            <!-- <el-form-item label="质管负责人电话：" prop="QualityMobile" label-width="180px">
              <el-input v-model="ruleForm.QualityMobile" placeholder="请填写质管负责人联系电话"></el-input>
            </el-form-item> -->
            <el-form-item label="产品检测手段：" label-width="180px" prop="ProductTestingMethod">
              <el-input v-model="ruleForm.ProductTestingMethod" type="textarea" rows="1" placeholder="请填写产品检测手段"> </el-input>
            </el-form-item>
            <el-form-item label="售后服务承诺和措施：" label-width="180px" prop="AfterSalesService">
              <el-input v-model="ruleForm.AfterSalesService" type="textarea" rows="1" placeholder="请填写售后服务承诺和措施"> </el-input>
            </el-form-item>
            <el-form-item label="营业期限：" prop="BusinessTermDate" label-width="180px" class="businessTermDate rangeDate" v-if="ruleForm.IsLongBusinessDate">
              <div class="datepicker_wrap">
                <el-date-picker class="filedate filedate1" value-format="yyyy-MM-dd" v-model="ruleForm.BusinessTermDate[0]" type="date" placeholder="开始日期"></el-date-picker>
              </div>
              <el-checkbox v-model="ruleForm.IsLongBusinessDate" class="term" @change="longterm">长期</el-checkbox>
            </el-form-item>
            <el-form-item label="营业期限：" prop="BusinessTermDate" label-width="180px" class="businessTermDate rangeDate" v-else>
              <el-date-picker v-model="ruleForm.BusinessTermDate" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels></el-date-picker>
              <el-checkbox v-model="ruleForm.IsLongBusinessDate" class="term" @change="longterm">长期</el-checkbox>
            </el-form-item>
            <el-form-item label="公司简介：" prop="CompanyProfile" label-width="180px">
              <el-input type="textarea" rows="1" v-model="ruleForm.CompanyProfile" placeholder="请填写公司简介"></el-input>
            </el-form-item>
            <!-- <el-form-item label="注册币种：" prop="RegisteredCurrency" label-width="180px" ref="RegisteredCurrency">
              <el-select v-model="ruleForm.RegisteredCurrency" placeholder="请选择" @change="RegisteredCurrencyFn"
                class="width_full">
                <el-option v-for="item in ruleForm.RegisteredCurrencyList" :key="item.value" :label="item.text"
                  :value="item.value" :checked="item.selected"></el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item label="质量校验人数：" label-width="180px">
              <el-input type="number" v-model="ruleForm.QualityCheckerNumber" placeholder="请填写质量校验人数"></el-input>
            </el-form-item> -->
          </div>
        </el-form>
      </div>

      <div class="line"></div>
    </div>

    <IntellectualPropertyFrom :IntellectualPropertyList="ruleForm.IntellectualPropertyList" :PropertyStateList="ruleForm.PropertyStateList" ref="IntellectualPropertyFrom" />

    <div class="form_wrap">
      <span class="title">联系人信息</span>
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm2">
          <div class="form_left">
            <el-form-item label="联系人名称：" prop="Contact" label-width="180px">
              <el-input v-model="ruleForm.Contact" placeholder="请填写联系人名称"></el-input>
            </el-form-item>
            <el-form-item label="手机号码：" prop="Mobile" label-width="180px">
              <el-input v-model="ruleForm.Mobile" placeholder="请填写手机号码"></el-input>
            </el-form-item>
            <!-- <el-form-item label="证件类型：" prop="CertificateType" label-width="180px" ref="CertificateType">
              <el-select class="width_full" v-model="ruleForm.CertificateType" placeholder="请选择"
                @change="CertificateTypeFn">
                <el-option v-for="item in ruleForm.CertificateTypeList" :key="item.value" :label="item.text"
                  :value="item.value" :checked="item.selected"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码：" prop="CertificateNo" label-width="180px">
              <el-input v-model="ruleForm.CertificateNo" placeholder="请填写证件号码"></el-input>
            </el-form-item> -->
          </div>
          <div class="form_right">
            <el-form-item label="电子邮箱：" prop="Email" label-width="180px">
              <el-input v-model="ruleForm.Email" placeholder="请填写电子邮箱"></el-input>
            </el-form-item>
            <!-- <el-form-item label="联系地址：" prop="ContactAddress" label-width="180px">
              <el-input v-model="ruleForm.ContactAddress" placeholder="请填写联系地址"></el-input>
            </el-form-item> -->
          </div>
        </el-form>
      </div>
      <div class="line"></div>
    </div>
    <div class="form_wrap">
      <span class="title">银行收款信息</span>
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm3">
          <div class="form_left">
            <el-form-item label="开户名称：" prop="BankAccountName" label-width="180px">
              <el-input v-model="ruleForm.BankAccountName" placeholder="请填写开户名称"></el-input>
            </el-form-item>

            <el-form-item label="开户银行名称：" prop="Bank" label-width="180px">
              <el-input v-model="ruleForm.Bank" placeholder="请填写开户银行名称"></el-input>
            </el-form-item>
          </div>
          <div class="form_right">
            <el-form-item label="开户银行账户：" prop="BankAccount" label-width="180px">
              <el-input v-model="ruleForm.BankAccount" placeholder="请填写开户银行账户"></el-input>
            </el-form-item>
            <el-form-item label="联行号：" prop="BankApprovalNumber" label-width="180px">
              <el-input v-model="ruleForm.BankApprovalNumber" maxlength="12" placeholder="请填写联行号"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="line"></div>
    </div>
    <div class="form_wrap">
      <span class="title">产品或服务信息</span>
      <div class="form">
        <ProductInfo :ProductSource="ruleForm.ProductSource" :ProductSourceList="ruleForm.ProductSourceList" :AgentBrandList="ruleForm.AgentBrandList" ref="ProductInfo" />
      </div>
    </div>
    <MsgForm :FileList.sync="FileList1" v-if="FileList1.length" :TaxPayerSize="ruleForm.TaxPayerSize" ref="MsgForm" />
    <SupplierType :tableData="ruleForm.SupplierTypeTree" :tableData1="ruleForm.SupplierTypeList" :dialogvisible.sync="dialogvisible" :selectSupplierType.sync="selectSupplierType"></SupplierType>
    <div class="btn_wrap" v-if="isEdit">
      <span class="btn_1" @click="submit(false)">保存草稿</span>
      <span class="btn_1" @click="submit(true)">提交申请</span>
    </div>
  </div>
</template>

<script>
import SupplierType from './SupplierType.vue'
import MsgForm from '@/components/common/MsgForm'
import ProductInfo from '@/components/common/ProductInfo'
import IntellectualPropertyFrom from '@/components/common/IntellectualPropertyFrom'
import { validateEmail, validatemobile1, validateIdCar2, validateSocialCreditCode, validContact } from '@/assets/js/util'
export default {
  components: {
    MsgForm,
    ProductInfo,
    IntellectualPropertyFrom,
    SupplierType
  },
  props: {
    parentForm: Object
  },
  data() {
    var validRegisteredAddress = (rule, value, callback) => {
      if (this.ruleForm.RegisteredAddressArr[0] == null || this.ruleForm.RegisteredAddress == '') {
        callback(new Error('请填写注册地址'))
      } else {
        // 其他统一的验证逻辑
        callback()
      }
    }
    var validOfficeAddress = (rule, value, callback) => {
      if (this.ruleForm.OfficeAddressArr[0] == null || this.ruleForm.OfficeAddress == '') {
        callback(new Error('请填写办公地址'))
      } else {
        // 其他统一的验证逻辑
        callback()
      }
    }
    return {
      value: '',
      treeprops: {
        label: 'name',
        Child: 'children'
      },
      ReferrerName: '',
      selectSupplierType: [],
      dialogvisible: false,
      userList: [{ UserId: '', UserName: '', Mobile1: '' }],
      isEdit: false,
      allQualificationCheck: '',
      allEnclosureCheck: '',
      ruleForm: {},
      FileList1: [],
      rules: {
        SupplierName: [{ required: true, message: '请输入供应商名称', trigger: 'blur' }],
        SocialCreditCode: [{ required: true, message: '', trigger: 'blur' }],
        SupplierType: [{ required: true, message: '请选择供应商类型', trigger: 'blur' }],
        LegalRepresentative: [{ required: true, message: '请输入法定代表人', trigger: 'blur' }],
        RegisteredCapital: [{ required: true, message: '请输入注册资本', trigger: 'blur' }],
        CompanyReputation: [{ required: true, message: '请输入企业信誉', trigger: 'blur' }],
        PaidInCapital: [{ required: true, message: '请输入实缴资本', trigger: 'blur' }],
        AfterSalesService: [{ required: true, message: '请输入售后服务承诺和措施', trigger: 'blur' }],
        ReferrerName: [{ required: this.ReferrerNameVaildate, message: '请输入推荐人', trigger: 'blur' }],
        SupplierType: [{ required: true, message: '请选择供应商类型', trigger: 'blur' }],
        SupplierNature: [{ required: true, message: '请选择供应商性质', trigger: 'blur' }],
        SupplierProductList: [{ required: true, validator: this.SupplierProductVaildate, message: '请选择供核心产品', trigger: 'blur' }],
        // SupplierProductBrandList: [{ required: true, message: '请选择供核心产品品牌', trigger: 'blur' }],
        StaffSize: [{ required: true, message: '请选择人员规模', trigger: 'blur' }],
        BusinessTermDate: [{ required: true, message: '请输入营业期限', trigger: 'blur' }],
        BusinessScope: [{ required: true, message: '请输入经营范围', trigger: 'blur' }],
        RegisteredAddress: [{ required: true, message: '请输入注册地址', trigger: 'blur', validator: validRegisteredAddress }],
        OfficeAddress: [{ required: true, message: '请输入办公地址', trigger: 'blur', validator: validOfficeAddress }],
        CompanyProfile: [{ required: true, message: '请输入公司简介', trigger: 'blur' }],
        Contact: [{ required: true, validator: validContact, trigger: 'blur' }],
        CertificateType: [{ required: true, message: '请选择证件类型', trigger: 'blur' }],
        CertificateNo: [{ required: true, message: '请输入正确的证件号', trigger: 'blur' }],
        Bank: [{ required: true, message: '请输入开户银行名称', trigger: 'blur' }],
        BankAccount: [{ required: true, message: '请输入开户银行账户', trigger: 'blur' }],
        BankApprovalNumber: [{ required: true, message: '请输入联行号', trigger: 'blur' }],
        CompanyType: [{ required: true, message: '请选择公司类型', trigger: 'blur' }],
        IntroductionSource: [{ required: true, message: '请选择引入来源', trigger: 'blur' }],
        RegistrationAuthority: [{ required: true, message: '请填写登记机关', trigger: 'blur' }],
        ContactAddress: [{ required: true, message: '请填写联系地址', trigger: 'blur' }],
        ProductSource: [{ required: true, message: '请选择产品来源', trigger: 'blur' }],
        TaxPayerSize: [{ required: true, message: '请选择纳税人规模', trigger: 'blur' }],
        Email: [{ required: true, validator: validateEmail, trigger: 'blur' }],
        Mobile: [{ required: true, validator: validatemobile1, trigger: 'blur' }],
        // QualityDirector: [{ required: true, message: '请填写质管负责人', trigger: 'blur' }],
        // QualityMobile: [{ required: true, validator: validatemobile1, trigger: 'blur' }],
        FixedAssets: [{ required: false, message: '请输入固定资产', trigger: 'blur' }],
        WorkerNumber: [{ required: false, message: '请输入生产工人数', trigger: 'blur' }],
        QualityManagerNumber: [{ required: false, message: '请输入质量管理人数', trigger: 'blur' }],
        TechnicianNumber: [{ required: false, message: '请输入技术人员数', trigger: 'blur' }],
        ProductTestingMethod: [{ required: false, message: '请输入产品检测手段', trigger: 'blur' }],
        CompanyDimension: [{ required: true, message: '请选择公司维度', trigger: 'blur' }],
        LastYearTotalSales: [{ required: true, message: '请输入去年销售总额', trigger: 'blur' }],
        // MajorProject: [{ required: true, message: '请填写主要产品或服务', trigger: 'blur' }],
        BankAccountName: [{ required: true, message: '请填写开户名称', trigger: 'blur' }]
      },
      isSupplierOtherType: false,
      socialCreditCode: ''
    }
  },
  computed: {
    CertificateType() {
      return this.ruleForm.CertificateType
    },
    SocialCreditCode() {
      return this.ruleForm.SocialCreditCode
    },
    RegisteredCapital() {
      return this.ruleForm.RegisteredCapital
    },
    FixedAssets() {
      return this.ruleForm.FixedAssets
    },
    LastYearTotalSales() {
      return this.ruleForm.LastYearTotalSales
    },
    // ReferrerName() {
    //   return this.ruleForm.ReferrerName
    // },
    ReferrerNameVaildate() {
      return this.ruleForm.IntroductionSource == '0' ? true : false
    }
    // PostalCode() {
    //   return this.ruleForm.PostalCode;
    // }
  },
  watch: {
    // ReferrerName(newVal) {
    //   const reg = /^1[3-9]{1}[0-9]{9}$/
    //   if (reg.test(newVal)) {
    //     this.ruleForm.Referrer = 0
    //   }
    // },
    CertificateType(newVal, oldVal) {
      // if(newVal!==oldVal){
      //   this.ruleForm.CertificateNo="";
      // }
      if (newVal == 1) {
        //身份证验证
        this.rules.CertificateNo[0].validator = validateIdCar2
      } else {
        delete this.rules.CertificateNo[0].validator
      }
    },
    // SocialCreditCode(newVal, oldVal) {
    //   if (this.isEdit) {
    //     if (newVal == this.socialCreditCode) {
    //       delete this.rules.SocialCreditCode[0].validator;
    //     } else {
    //       this.rules.SocialCreditCode[0].validator = validateSocialCreditCode;
    //     }
    //   }
    // },
    RegisteredCapital(newVal, oldVal) {
      this.ruleForm.RegisteredCapital = newVal.match(/^\d*(\.?\d{0,3})/g)[0]
    },
    FixedAssets(newVal, oldVal) {
      this.ruleForm.FixedAssets = newVal.match(/^\d*(\.?\d{0,3})/g)[0]
    },
    LastYearTotalSales(newVal, oldVal) {
      this.ruleForm.LastYearTotalSales = newVal.match(/^\d*(\.?\d{0,3})/g)[0]
    },
    PostalCode(newVal, oldVal) {
      if (newVal.length > 6) {
        this.ruleForm.PostalCode = newVal.substr(0, 6)
      }
    },
    selectSupplierType(newVal, oldVal) {
      var isVaildate = false
      this.ruleForm.SupplierTypeName = []
      this.ruleForm.SupplierType = []
      newVal.forEach((item) => {
        this.ruleForm.SupplierTypeName.push(item.firstName + '-' + item.secondName + '-' + item.supplierTypeName)
        this.ruleForm.SupplierType.push(item.paramItemCode)
        if (item.paramItemCode.indexOf('GC') >= 0 || item.paramItemCode.indexOf('SP') >= 0) {
          isVaildate = true
        }
      })
      if ((isVaildate = true)) {
        this.rules.FixedAssets[0].required = true
        this.rules.WorkerNumber[0].required = true
        this.rules.QualityManagerNumber[0].required = true
        this.rules.TechnicianNumber[0].required = true
        this.rules.ProductTestingMethod[0].required = true
        this.rules.SupplierProductList[0].required = true
      } else {
        this.rules.FixedAssets[0].required = false
        this.rules.WorkerNumber[0].required = false
        this.rules.QualityManagerNumber[0].required = false
        this.rules.TechnicianNumber[0].required = false
        this.rules.ProductTestingMethod[0].required = false
        this.rules.SupplierProductList[0].required = false
      }
    },
    ReferrerNameVaildate(newVal) {
      this.rules.ReferrerName[0].required = newVal
    }
  },

  mounted() {
    this.getList()
    // if (!this.isEdit) {
    //   this.rules.SocialCreditCode[0].validator = validateSocialCreditCode;
    // }
  },
  methods: {
    SupplierProductVaildate(rule, value, callback) {
      if (this.ruleForm.SupplierProductList.length == 0 && this.ruleForm.OtherSupplierProductList === '') {
        callback(new Error('请填写核心产品'))
      } else {
        // 其他统一的验证逻辑
        callback()
      }
    },
    getList() {
      let loginName

      if (this.$route.query.loginName) {
        loginName = this.$route.query.loginName
        this.isEdit = true
      } else {
        loginName = this.parentForm.enloginName
      }
      this.postRequest('SupplierLogin/BaseDataEdit', {
        loginName: loginName
      }).then((res) => {
        if (res.data.errcode == 0) {
          this.userList = res.data.data.UserList
          this.ruleForm = res.data.data
          this.FileList1 = res.data.data.FileList1
          this.handleChange()
          if (this.ruleForm.RegisteredCapital == 0) {
            this.ruleForm.RegisteredCapital = ''
          }
          this.socialCreditCode = this.ruleForm.SocialCreditCode
          // this.rules.BusinessTermEndDate[0].required = !this.ruleForm
          //   .IsLongBusinessDate;
          if (this.ruleForm.SupplierId == 0) {
            this.ruleForm.BusinessTermDate = ['', '']
            this.ruleForm.SupplierNature = ''
          }
          console.log(this.ruleForm.IntellectualPropertyList)
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    longterm(val) {
      if (val) {
        if (!this.ruleForm.BusinessTermDate) {
          this.ruleForm.BusinessTermDate = ['', '']
        }
      } else {
        this.ruleForm.BusinessTermDate = []
      }
    },
    handleChange(val) {
      if (val) {
        this.$refs['SupplierType'].clearValidate()
      }
      //供应商
      if (this.ruleForm.SupplierType.includes(0)) {
        this.isSupplierOtherType = true
      } else {
        this.isSupplierOtherType = false
      }
    },
    focusError() {
      setTimeout(() => {
        if (document.getElementsByClassName('el-form-item__error').length > 0) {
          // console.log(
          //   document.getElementsByClassName("el-form-item__error")[0]
          // );
          this.$message.error(document.getElementsByClassName('el-form-item__error')[0].innerText)
        }
      }, 500)
    },
    validateSupplierType() {
      var issumit = true
      if (this.ruleForm.BusinessTermDate[0] == '' && issumit == true) {
        this.$message.error('请选择营业期限')
        issumit = false
        return false
      }
      if (this.ruleForm.SupplierType.length == 0 && issumit == true) {
        this.$message.error('请选择供应商类型')
        issumit = false
        return false
      }
      if (this.ruleForm.Referrer == 0 && this.ruleForm.IntroductionSource == '0' && issumit == true) {
        this.$message.error('请填写推荐人')
        issumit = false
        return false
      }
      // let arr = this.$refs.treerefs.getCheckedKeys();
      // let arr1 = this.$refs.treerefs.getCheckedNodes();
      // if (arr.length == 0) {
      //   this.$message.error("请选择供应商类型");
      //   return false;
      // }
      // arr1.forEach(item => {
      //   if (item.other && issumit) {
      //     if (!document.getElementById(item.id).value) {
      //       this.$message.error("请输入其他供应商类型");
      //       issumit = false;
      //     } else {
      //       item.othervalue = document.getElementById(item.id).value;
      //     }
      //   }
      // });
      // this.ruleForm.SupplierType = JSON.stringify(arr1);
      return issumit
    },

    formRule() {
      return new Promise((resolve, reject) => {
        var flag = this.validateSupplierType()
        // console.log(flag);
        if (flag) {
          this.$refs.ruleForm1.validate((valid) => {
            if (valid) {
              this.$refs.ruleForm4.validate((valid1) => {
                if (valid1) {
                  this.$refs.ruleForm2.validate((valid2) => {
                    if (valid2) {
                      this.$refs.ruleForm3.validate((valid3) => {
                        resolve(true)
                        if (valid3) {
                          resolve(true)
                        } else {
                          this.focusError()
                          resolve(false)
                        }
                      })
                    } else {
                      this.focusError()
                      resolve(false)
                    }
                  })
                } else {
                  this.focusError()
                  resolve(false)
                }
              })
            } else {
              this.focusError()
              resolve(false)
            }
          })
        } else {
          resolve(false)
        }

        //
      })
    },
    async submit(submit) {
      // console.log(this.ruleForm.SupplierProductList.length == 0 && this.ruleForm.OtherSupplierProductList === '')
      if (submit) {
        let isSubmit = await this.formRule()
        this.$refs.MsgForm.ruleList()
        this.$refs.ProductInfo.ruleList()
        this.$refs.IntellectualPropertyFrom.ruleList()
        console.log('sss', isSubmit)
        if (this.$refs.MsgForm.iserror && isSubmit && this.$refs.ProductInfo.iserror && this.$refs.IntellectualPropertyFrom.iserror) {
          this.save(submit)
        }
      } else {
        this.$refs.MsgForm.ruleList1()
        this.$refs.ProductInfo.ruleList1()
        this.save(submit)
      }
    },
    save(isSubmit) {
      this.ruleForm.ProductSource = this.$refs.ProductInfo.ruleForm.ProductSource
      this.postRequest('SupplierLogin/BaseDataSave', {
        fileListJson: JSON.stringify(this.$refs.MsgForm.list),
        baseDataJson: JSON.stringify(this.ruleForm),
        agentBrandListJson: JSON.stringify(this.$refs.ProductInfo.list),
        intellectualPropertyListJson: JSON.stringify(this.$refs.IntellectualPropertyFrom.PropertyList),
        isSubmit: isSubmit
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            if (isSubmit) {
              this.$router.push({
                //传外键值到审核进度详细页面
                path: '/SuccessApply',
                query: { name: '注册流程信息' }
              })
            } else {
              this.$router.push({
                //传外键值到审核进度详细页面
                path: '/RegisterForm',
                query: { loginName: res.data.loginName }
              })
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    scaleNum(val) {
      if (val) {
        this.$refs['scalenum'].clearValidate()
      }
    },
    RegisteredCurrencyFn(val) {
      if (val) {
        this.$refs['RegisteredCurrency'].clearValidate()
      }
    },
    CertificateTypeFn(val) {
      if (val) {
        this.$refs['CertificateType'].clearValidate()
      }
    },
    CompanyTypeFn(val) {
      if (val) {
        this.$refs['CompanyType'].clearValidate()
      }
    },
    IntroductionSourceFn(val) {
      if (this.ruleForm.IntroductionSource == 1) {
        if (this.ruleForm.SocialCreditCode == '' || this.ruleForm.SocialCreditCode == null) {
          this.ruleForm.IntroductionSource = '0'
          this.$message.error('请先输入社会信用代码后选择引入来源')
        }
        this.postRequest('SupplierLogin/ValidateIntroductionSource', {
          socialCreditCode: this.ruleForm.SocialCreditCode
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.rules.ReferrerName[0].required = false
          } else {
            this.$message.error(res.data.errmsg)
            this.ruleForm.IntroductionSource = '0'
          }
        })
      } else {
        this.rules.ReferrerName[0].required = true
      }
    },
    // renderContent(h, { node, data, store }) {
    //   if (data.other) {
    //     return (
    //       <span class="custom-tree-node">
    //         <span> {node.label} </span>{" "}
    //         <input
    //           id={data.id}
    //           value={data.othervalue}
    //           style="height:26px;line-height:26px;margin-left:5px"
    //           class="el-input__inner otherinput"
    //         />{" "}
    //       </span>
    //     );
    //   } else {
    //     return (
    //       <span class="custom-tree-node">
    //         <span> {node.label} </span>{" "}
    //       </span>
    //     );
    //   }
    // },
    querySearchAsync() {
      var users = this.ruleForm.UserList
      const reg = /^1[3-9]{1}[0-9]{9}$/
      var results = this.ReferrerName
        ? users.filter((item) => {
            return item.Mobile1 == this.ReferrerName
          })
        : []
      if (!reg.test(this.ReferrerName)) {
        this.$message.error('请输入正确的推荐人手机号！')
        this.ruleForm.Referrer = 0
      }
      if (reg.test(this.ReferrerName) && results.length == 0) {
        this.$message.error('供应商入库推荐人的手机号码默认为我司员工在我司系统报备号码，现查无此人，请联系我司对接人员！')
        this.ruleForm.Referrer = 0
      }
      if (results.length > 0) {
        this.ruleForm.Referrer = results[0].UserId
        this.ruleForm.ReferrerName = results[0].UserName
        this.ruleForm.ReferrerMobile = results[0].Mobile1
      }
    },
    deleteReferrerName() {
      this.ruleForm.Referrer = 0
      this.ruleForm.ReferrerName = ''
      this.ruleForm.ReferrerMobile = ''
    },
    // createFilter(queryString) {
    //   return user => {
    //     return (
    //       String(user.Mobile1)===queryString
    //     );
    //   };
    // },
    handleSelect(item) {
      this.ruleForm.Referrer = item.UserId
      this.ruleForm.ReferrerName = item.UserName
      this.ruleForm.ReferrerMobile = item.Mobile1
    },
    openSupplierTypePage() {
      this.dialogvisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.userName {
  text-overflow: ellipsis;
  overflow: hidden;
}
.mobile {
  font-size: 12px;
  color: #b4b4b4;
}
.form_wrap .is-active {
  border-color: #fff !important;
  background: #fff !important;
}

.supplierType {
  .el-checkbox-group {
    label {
      display: inline-block;
      width: 108px;
    }
  }

  ::v-deep .el-form-item__content {
    .el-form-item__error {
      top: 98% !important;
    }
  }
}

.supplierOtherType {
  display: inline-block;
  margin: 0 0 0 -45px;

  ::v-deep .el-form-item__content {
    .el-form-item__error {
      top: 105% !important;
    }
  }
}

.btn_wrap {
  width: 500px;
  margin: 30px auto 50px;

  .btn_1 {
    font-weight: bold;
    margin: 0 30px;
  }

  .btn {
    color: #fff;
    background: #2db7f5;
  }
}

.businessTermDate {
  .el-input {
    width: 364px !important;
  }

  .businessTermEndDate {
    margin-bottom: 0 !important;
    margin-left: 10px;

    .el-input {
      width: 100% !important;
    }

    ::v-deep.el-form-item__label:before {
      display: none;
    }
  }
}

.rangeDate ::v-deep.el-form-item__content {
  .el-input__inner,
  .el-range-editor {
    width: 100% !important;
    text-align: center;

    .el-range-input {
      font-size: 14px;
    }
  }
}

// .tree ::v-deep .el-tree-node {
//   .el-tree-node__children {
//     white-space: normal;
//     .el-tree-node {
//       display: inline-block;
//     }
//   }
// }
.tree {
  width: 400px;
  background: transparent !important;
}

.width_full {
  width: 100% !important;
}
.width_full1 {
  width: 80% !important;
}
.input_number ::v-deep .el-input-number__decrease {
  display: none;
}

.input_number ::v-deep .el-input-number__increase {
  display: none;
}

.input_number ::v-deep .el-input__inner {
  padding-left: 10px !important;
  padding-right: 10px !important;
  width: 303% !important;
}
.addressCascader {
  width: 180px;
}
.cascader {
  ::v-deep .el-input-group__prepend {
    padding: unset;
    border: unset;
    border-radius: unset;
  }
}
.name_wrap {
  border: 1px solid #606266;
  margin-left: 11px;
  border-radius: 10px;
  padding: 0 4px;
}

.name_wrap2 {
  display: inline-block;
  padding: 5px;
}
</style>